import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductsSharingsListItem } from "../../sharing.types";
import { requestProductsSharings } from "./productsSharings.request";

const useProductSharings = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<ProductsSharingsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["admin", "product-sharings", "sharings", requestParams],
    queryFn: async () => await requestProductsSharings(requestParams),
    ...options
  });

  return { productsSharings: data?.data, meta: data?.meta, ...rest };
};

export default useProductSharings;
